module.exports = __webpack_public_path__ + "static/pic03-cb1d5ced8ddc6b435c78b0761c230d82.jpg";